import { ControlUnitAPIResponse } from '../../../redux/controlUnit/api/ControlUnit.model';
import { MachineType } from '../../../redux/stoerkID/StoerkIdAPI.model';

export const getChannelsByComposableDevice = (
  machineType: MachineType,
  controlUnits: ControlUnitAPIResponse[],
  commanderId: string
) => {
  const channelList = [];

  const actionsChannelsIndex =
    machineType?.labels['merchandise_channel_actions']?.split('-') || [];
  const [initialActionsChannels, endActionsChannels] = actionsChannelsIndex.map(
    (value) => parseInt(value, 10)
  );

  const eventsChannelsIndex =
    machineType?.labels['merchandise_channel_events']?.split('-') || [];
  const [initialEventChannels, endEventChannels] = eventsChannelsIndex.map(
    (value) => parseInt(value, 10)
  );
  const sensorChannelsIndex =
    machineType?.labels['merchandise_channel_sensors']?.split('-') || [];
  const [initialSensorChannels, endSensorChannels] = sensorChannelsIndex.map(
    (value) => parseInt(value, 10)
  );

  const virtualChannelsIndex =
    machineType?.labels['merchandise_channel_virtual_sensors']?.split('-') ||
    [];
  const [initialVirtualChannels, endVirtualChannels] = virtualChannelsIndex.map(
    (value) => parseInt(value, 10)
  );

  for (let i = initialActionsChannels; i <= endSensorChannels; i++) {
    const channelAddress = machineType?.labels[`channels.${i}.address`];
    const channel = machineType?.labels[`channels.${i}.channel`] ?? '';

    const controlUnit = controlUnits.find(
      (cu) => cu.address === channelAddress
    );
    const channelType =
      i < initialEventChannels
        ? 'action'
        : i < initialSensorChannels
        ? 'event'
        : 'sensordata';

    const value = {
      deviceId: commanderId,
      controlUnitId: controlUnit?.id ?? '',
      channel,
      channelType,
    };
    channelList.push(value);
  }
  //add virtual channels
  const virtualChannels = [
    {
      deviceId: commanderId,
      controlUnitId: '',
      channel: '',
      channelType: 'virtual_superheat',
    },
    {
      deviceId: commanderId,
      controlUnitId: '',
      channel: '',
      channelType: 'virtual_superheat',
    },
  ];
  for (let i = initialVirtualChannels; i <= endVirtualChannels; i++) {
    channelList.push(virtualChannels[i - initialVirtualChannels]);
  }

  return channelList;
};
